import React, { Component } from "react";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {withNamespaces} from "react-i18next";
import LogDeviceTable from "./_components/LogDeviceTable";

class LogPage extends Component {

    render() {
        const breadcrumb = [{ value: 'logs', path: '#' }];
        const { t } = this.props;

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <div className="row">
                    <h4 className="col-md-6">{t('logs')}</h4>
                </div>

                <div className="card">
                    <div className="card-body">
                        <LogDeviceTable />
                    </div>
                </div>
            </div>
        );
    }
}
export default withNamespaces()(LogPage);
